/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OperationMetadataProgress } from './OperationMetadataProgress';
import {
    OperationMetadataProgressFromJSON,
    OperationMetadataProgressFromJSONTyped,
    OperationMetadataProgressToJSON,
} from './OperationMetadataProgress';
import type { OperationMetadataRetry } from './OperationMetadataRetry';
import {
    OperationMetadataRetryFromJSON,
    OperationMetadataRetryFromJSONTyped,
    OperationMetadataRetryToJSON,
} from './OperationMetadataRetry';

/**
 * Additional operation details (e.g. objects, retry info, read progress, successfulRecordIds).
 * @export
 * @interface OperationMetadata
 */
export interface OperationMetadata {
    /**
     * 
     * @type {Array<string>}
     * @memberof OperationMetadata
     */
    objects?: Array<string>;
    /**
     * 
     * @type {OperationMetadataRetry}
     * @memberof OperationMetadata
     */
    retry?: OperationMetadataRetry;
    /**
     * 
     * @type {OperationMetadataProgress}
     * @memberof OperationMetadata
     */
    progress?: OperationMetadataProgress;
    /**
     * Provider-assigned IDs of successfully created or updated records. Only present for write operations.
     * @type {Array<string>}
     * @memberof OperationMetadata
     */
    successfulRecordIds?: Array<string>;
}

/**
 * Check if a given object implements the OperationMetadata interface.
 */
export function instanceOfOperationMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperationMetadataFromJSON(json: any): OperationMetadata {
    return OperationMetadataFromJSONTyped(json, false);
}

export function OperationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : json['objects'],
        'retry': !exists(json, 'retry') ? undefined : OperationMetadataRetryFromJSON(json['retry']),
        'progress': !exists(json, 'progress') ? undefined : OperationMetadataProgressFromJSON(json['progress']),
        'successfulRecordIds': !exists(json, 'successfulRecordIds') ? undefined : json['successfulRecordIds'],
    };
}

export function OperationMetadataToJSON(value?: OperationMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects,
        'retry': OperationMetadataRetryToJSON(value.retry),
        'progress': OperationMetadataProgressToJSON(value.progress),
        'successfulRecordIds': value.successfulRecordIds,
    };
}

